import { render, staticRenderFns } from "./fair-modal.vue?vue&type=template&id=959961da&scoped=true&"
import script from "./fair-modal.vue?vue&type=script&lang=js&"
export * from "./fair-modal.vue?vue&type=script&lang=js&"
import style0 from "./fair-modal.vue?vue&type=style&index=0&id=959961da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959961da",
  null
  
)

export default component.exports